<template>
  <vs-textarea ref="mlTextarea" :rows="rows" :counter="max" v-model="inputValue" :readonly="readonly" :placeholder="placeholder" class="mb-3" />
</template>

<script>
import * as UiUtil from "@/util/UiUtil";
export default {
  name: "MaxLengthTextarea",
  props: {
    value: { type: String | Number, default: "" },
    placeholder: String,
    readonly: Boolean,
    rows: { type: Number | String, default: 5 },
    max: { type: Number, default: 2000 },
  },
  watch: {
    value: {
      handler(value) {
        this.inputValue = value;
      },
    },
    inputValue: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > this.max) {
          this.inputValue = this.value;
          UiUtil.alertDialog(`${this.max}자까지 작성할 수 있습니다.`);
          // this.$refs.mlTextarea.focus();
        } else {
          this.$emit("input", value);
        }
      },
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
};
</script>

<style lang="scss" scoped></style>
